// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.css */
.icon-right-margin {
  margin-right: 8px; /* Adjust the value as needed */
}

.dropdown-item-full-width {
  display: block; /* Ensure DropdownItem is full width */
  text-align: center; /* Center text */
}

.dropdown-button-full-width {
  width: 100%; /* Make button full width */
  text-align: center; /* Center text inside button */
  justify-content: center; /* Center for Flexbox layouts, if applicable */
  font-size: 1rem !important;
}

/* icons.css */
.icon-size-20 {
  width: 20px;
  height: 20px;
}
.btn-smaller-height {
  height: 41px;
}

.dropdown-background {
  z-index: -1;
  opacity: 0.3;
}

.dropdown-item-custom {
  display: flex;
  align-items: center;
}

.terms-and-conditions-dropdown {
  display: flex;
  padding: 0;
  margin-right: -58px; /* Adjust this value as needed */
  padding-left: 10px;
}

.terms-and-conditions-link-container {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  background-color: transparent;
}

.terms-and-conditions-link {
  text-decoration: none !important;
  font-size: 0.8rem;
}

.divider {
  align-self: center;
  font-size: 0.8rem;
  margin: 0 10px;
  margin-left: 60px;
}

.contact-us-dropdown {
  display: flex;
  padding: 0;
}

.contact-us-link-container {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  margin-left: -10px;
  background-color: transparent;
}

.contact-us-link {
  text-decoration: none !important;
  font-size: 0.8rem;
}

.dropdown-item-center {
  display: flex;
  justify-content: center;
  width: 100%;
}

.contact-us-center-container {
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/headerDropdown.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,iBAAiB,EAAE,+BAA+B;AACpD;;AAEA;EACE,cAAc,EAAE,sCAAsC;EACtD,kBAAkB,EAAE,gBAAgB;AACtC;;AAEA;EACE,WAAW,EAAE,2BAA2B;EACxC,kBAAkB,EAAE,8BAA8B;EAClD,uBAAuB,EAAE,8CAA8C;EACvE,0BAA0B;AAC5B;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB,EAAE,gCAAgC;EACrD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["/* styles.css */\n.icon-right-margin {\n  margin-right: 8px; /* Adjust the value as needed */\n}\n\n.dropdown-item-full-width {\n  display: block; /* Ensure DropdownItem is full width */\n  text-align: center; /* Center text */\n}\n\n.dropdown-button-full-width {\n  width: 100%; /* Make button full width */\n  text-align: center; /* Center text inside button */\n  justify-content: center; /* Center for Flexbox layouts, if applicable */\n  font-size: 1rem !important;\n}\n\n/* icons.css */\n.icon-size-20 {\n  width: 20px;\n  height: 20px;\n}\n.btn-smaller-height {\n  height: 41px;\n}\n\n.dropdown-background {\n  z-index: -1;\n  opacity: 0.3;\n}\n\n.dropdown-item-custom {\n  display: flex;\n  align-items: center;\n}\n\n.terms-and-conditions-dropdown {\n  display: flex;\n  padding: 0;\n  margin-right: -58px; /* Adjust this value as needed */\n  padding-left: 10px;\n}\n\n.terms-and-conditions-link-container {\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 1rem;\n  background-color: transparent;\n}\n\n.terms-and-conditions-link {\n  text-decoration: none !important;\n  font-size: 0.8rem;\n}\n\n.divider {\n  align-self: center;\n  font-size: 0.8rem;\n  margin: 0 10px;\n  margin-left: 60px;\n}\n\n.contact-us-dropdown {\n  display: flex;\n  padding: 0;\n}\n\n.contact-us-link-container {\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 1rem;\n  margin-left: -10px;\n  background-color: transparent;\n}\n\n.contact-us-link {\n  text-decoration: none !important;\n  font-size: 0.8rem;\n}\n\n.dropdown-item-center {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.contact-us-center-container {\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
